///zsystemimporter/import
export const MODULE_FILE_CSV_UPLOAD = "MODULE_FILE_CSV_UPLOAD";
export const MODULE_FILE_CSV_UPLOAD_SUCCESS = "MODULE_FILE_CSV_UPLOAD_SUCCESS";
export const MODULE_FILE_CSV_UPLOAD_ERROR = "MODULE_FILE_CSV_UPLOAD_ERROR";
///zsystemimporter/availablemodulefields
export const MODULE_AVAILABLE_MODULE_FIELDS = "MODULE_AVAILABLE_MODULE_FIELDS";
export const MODULE_AVAILABLE_MODULE_FIELDS_SUCCESS =
  "MODULE_AVAILABLE_MODULE_FIELDS_SUCCESS";
export const MODULE_AVAILABLE_MODULE_FIELDS_ERROR =
  "MODULE_AVAILABLE_MODULE_FIELDS_ERROR";
///fileattachment/create/preauth
export const FILE_ATTACHMENT_CREATE_PREAUTH = "FILE_ATTACHMENT_CREATE_PREAUTH";
export const FILE_ATTACHMENT_CREATE_PREAUTH_SUCCESS =
  "FILE_ATTACHMENT_CREATE_PREAUTH_SUCCESS";
export const FILE_ATTACHMENT_CREATE_PREAUTH_ERROR =
  "FILE_ATTACHMENT_CREATE_PREAUTH_ERROR";
